import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";
import * as S from "./styles";
import ModalFilter from "components/ModalEditFilter";
import Switch from '@mui/material/Switch';
import { DownloadButton } from "components/Buttons/ActionButton";
import { getBeneficiaryType, convertDateFromApi, scrollToTop } from "utils";
import { filters } from "utils/constants";
import { useApi } from "hooks/useApis";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import AgentType from "utils/agentType";
import { useSelector } from 'react-redux';
import SuccessAlert from "components/Alerts/SuccessAlert";
import FillErrorAlert from "components/Alerts/FillErrorAlert";
import { serverErrorMsg } from "utils/constants";

const TableFilters = () => {
  const api = useApi();

  const [openModal, setOpenModal] = useState(false);

  const [valuesFilters, setValuesFilters] = useState({});

  const [indexFilter, setIndexFilter] = useState(0);

  const [alertType, setAlertType] = useState('');

  const [alertMessage, setAlertMessage] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const agentType = AgentType();

  const isManager = ['1'].includes(agentType);

  const widthTable = isManager ? '35%' : '40%'

  const user = useSelector((state) => state.user?.user);

  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const [active, setActive] = useState(false);

  const [key, setKey] = useState(0);

  const resetComponent = () => {
    setKey((prevKey) => prevKey + 1); // Incrementa a chave
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.getFilters();
        setValuesFilters([
          response?.verify_days_after_birth_without_registration,
          response?.verify_family_capacity,
          response?.verify_income_profile,
          // response?.verify_agent_work_location,
          response?.verify_resp_age,
          response?.verify_child_age,
          response?.verify_general_limit,
        ]);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [openModal]);

  const onSubmitEditValue = async (data) => {
    try {
      setIsLoading(true)
      const attributeName = filters[indexFilter].attributeName;
      console.log("submit: ", data);
      const formatedData = {
        [attributeName]: data.valueFilter,
        justification: data.justification
      };

      const response = await api.patchFilters(formatedData);
      setOpenModal(false)
      setIsLoading(false)
      setAlertType('success')
      setAlertMessage( `O filtro foi ${active? 'desativado':'ativado'} com sucesso!` )
    } catch (err) {
      setAlertType('error')
      setAlertMessage(err?.status === 500 ? serverErrorMsg : err?.response?.data?.detail)
      setIsLoading(false)
      console.log(err);
    }
  };



  const statusLabel = (status) => {
    return (
      <div
        style={{
          backgroundColor: status ? '#D4F8D3' : '#D1D1D1',
          color: '#000',
          padding: '5px 10px',
          borderRadius: '15px',
          display: 'inline-block',
          // fontWeight: '600',
        }}
      >
        {status ? 'Ativo' : 'Inativo'}
      </div>
    );
  };

  const onSwitch = (index) => {
    console.log("index: ", index, "valuesfilters: ", valuesFilters[index]);
    setOpenModal(true);
    setActive(valuesFilters[index])
    setIndexFilter(index)
  };



  return (
    <>
      <S.TableContainer key={key}>
        <S.StyledTable>
          <S.StyledTableHead>
            <tr>
              <S.StyledTableHeaderCell style={{ width: widthTable }}>Filtros</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell style={{ width: widthTable }}>Descrição</S.StyledTableHeaderCell>
              <S.StyledTableHeaderCell style={{ width: widthTable }}>Status</S.StyledTableHeaderCell>
              {isManager &&
                <S.StyledTableHeaderCell >Ação</S.StyledTableHeaderCell>}
            </tr>
          </S.StyledTableHead>
          <S.StyledTableBody>
            {filters?.map((row, index) => {
              return (
                <S.StyledTableRow key={row.id}>
                  <S.StyledTableCell>{row.filter}</S.StyledTableCell>
                  <S.StyledTableCell>{row.description}</S.StyledTableCell>
                  <S.StyledTableCell>
                    {statusLabel(valuesFilters[index])}
                  </S.StyledTableCell>
                  {isManager &&
                  <S.StyledTableCell>
                    <S.ButtonsContainer>
                      <Switch
                        checked={valuesFilters[index]}
                        onChange={() => onSwitch(index)}
                        {...label}
                        sx={{
                          // width: 60, // Aumenta a largura geral do switch
                          // height: 28, // Aumenta a altura geral do switch
                          // border: '1px solid red',
                          display: 'flex',
                          justifyContent: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          padding: 0,
                          '& .MuiSwitch-switchBase': {
                            padding: 0.9,
                            marginRight: 1,
                            // border: '1px solid red',

                            '&.Mui-checked': {
                              transform: 'translateX(26px)', // Ajuste do deslocamento da bolinha ao ativar
                              color: '#FFFFFF', // Cor da bolinha ativa
                            },
                          },
                          '& .MuiSwitch-thumb': {
                            width: 23, // Largura da bolinha
                            height: 23, // Altura da bolinha
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#38c45c', // Cor da barra quando ativo
                          },
                          '& .MuiSwitch-track': {

                            borderRadius: 34 / 2, // Deixa a barra arredondada
                            backgroundColor: '#D1D1D1', // Cor da barra inativa
                            opacity: 1,
                            transition: 'background-color 0.2s',
                            height: 28, // Altura da barra (igual à bolinha)
                            padding: 1,

                          },
                        }}
                      />
                    </S.ButtonsContainer>
                  </S.StyledTableCell>}
                </S.StyledTableRow>
              );
            })}
          </S.StyledTableBody>
        </S.StyledTable>
      </S.TableContainer>
      <ModalFilter
        open={openModal}
        handleClose={() => {setOpenModal(false); resetComponent()}}
        onSubmit={onSubmitEditValue}
        isLoading={isLoading}
        active={active}
      />
      <SuccessAlert
        open={alertType === "success"}
        onClose={() => { setAlertType(""); window.location.reload() }}
        alertText={alertMessage}
      />
      <FillErrorAlert
        open={alertType === "error"}
        onClose={() => setAlertType("")}
        message={alertMessage}
      />
    </>
  );
};

export default TableFilters;
